import { render } from "./Brand.vue?vue&type=template&id=1726cafe&scoped=true"
import script from "../js/brand.js?vue&type=script&lang=js"
export * from "../js/brand.js?vue&type=script&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=1726cafe&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1726cafe"]])

export default __exports__